import React from "react";
import Header from "./Header";
import Hero from "./Hero";
import PromoTreatmentList from "./PromoTreatmentList";
import ServicesGrid from "./ServicesGrid";
import About from "./About";
import Clinics from "./Clinics";

import TestimonialCarousel from "./TestimonialCarousel";

import ContactForm from "./ContactForm";
import Footer from "./Footer";
import FloatingWhatsApp from "./FloatingWhatsApp";

export default function MarvieLanding() {
  return (
    <div className="min-h-screen bg-bg">
      <Header />
      <main>
        <Hero />
        <PromoTreatmentList />
        <ServicesGrid />
        <About />
        <Clinics />

        <TestimonialCarousel />
        <ContactForm />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
